import { Injectable } from '@angular/core';

// Services
import { ServiceBase } from '../service-base';

const CLASS_NAME = 'AiSettings';
const ENDPOINT = `/ai-settings/`;

@Injectable({
    providedIn: 'root'
})
export class AiSettingsService extends ServiceBase {
    constructor() {
        super(CLASS_NAME, ENDPOINT);
    }
}
